import { AccountingAccountResponse } from '@/app/models/accountingAcount';
import { useDeleteAccountingAccountMutation } from '@/app/services/accountingAccountApi';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ModeEditOutlineTwoToneIcon from '@mui/icons-material/ModeEditOutlineTwoTone';
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ActionMenu, { ItemAction } from '../common/ActionMenu';

const HeaderTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
  fontWeight: 'bold',
}));

const RowTableCell = styled(TableCell)(() => ({
  fontSize: 13,
  justifyContent: 'space-between',
}));

type AccountingAccountTableParams = {
  rows: AccountingAccountResponse[];
  setSelectedItem: (p: AccountingAccountResponse) => void;
  setDrawerStatus: (p: boolean) => void;
};

export default function AccountingAccountTable(props: AccountingAccountTableParams) {
  const { t } = useTranslation(['accountingAccount', 'common']);
  const { rows, setSelectedItem, setDrawerStatus } = props;

  const [deleteAccountingAccount] = useDeleteAccountingAccountMutation();

  const handleDelete = async (id: number) => {
    const response = await deleteAccountingAccount(id);
    if ('data' in response) {
      toast.success(
        t('deleted.accounting.account', {
          position: toast.POSITION.TOP_RIGHT,
        }),
      );
    }
  };

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell>{t('type')}</HeaderTableCell>
            <HeaderTableCell>{t('accounting.account.code')}</HeaderTableCell>
            <HeaderTableCell>{t('common:type.project')}</HeaderTableCell>
            <HeaderTableCell colSpan={4} align="right">
              {t('common:actions')}
            </HeaderTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <RowTableCell>{row.accountType}</RowTableCell>
              <RowTableCell>{row.accountCode}</RowTableCell>
              <RowTableCell>{row.subType}</RowTableCell>
              <RowTableCell colSpan={4} align="right">
                <ActionMenu>
                  <ItemAction
                    text={t('common:delete')}
                    Icon={DeleteOutlineIcon}
                    onClick={() => {
                      handleDelete(row.id);
                    }}
                  />
                  <ItemAction
                    text={t('common:edit')}
                    Icon={ModeEditOutlineTwoToneIcon}
                    onClick={() => {
                      setSelectedItem(row);
                      setDrawerStatus(true);
                    }}
                  />
                </ActionMenu>
              </RowTableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={7}>
                <Typography variant="subtitle2">
                  {t('common:no.data.for.the.chosen.period.and.search.term')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
